import {
  Exchange,
  indicator,
  SelectedTimeFrame,
  TickerDetails,
  isLoading,
  Returns,
  RsClassic,
  RsFibbo,
  IndicatorData,
  SetError,
  WelcomePage,
  checked,
  isAuthenticated,
  authToken,
  meanReversion,
} from "./Action";

const initialState = {
  searchvalue: "",
  showAppBar: false,
  jsonData: {},
  jsonRSL: [],
  jsonReturns: {},
  jsonVol: {},
  TickerName: [],
  TickerDetails: [],
  ActiveButton: "Daily",
  SelectedDropdownOption: "Indicator",
  SetPage: 0,
  RowsPerPage: 10,
  RsClassic: [],
  RsFibo: [],
  Returns: [],
  SetExchange: "NSE",
  isLoading: false,
  SearchItems: "",
  TableItem: [],
  SetError: null,
  welcomePage: true,
  // checked:["1d","1w","1mn"],
  isAuthenticated: false,
  authToken: null,
  selectedAnalytics: "",
  sample: [],
  VolumeAnalysis: [],
  MeanReversion: [],
  keyMetrics: [],
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "JSONDATA":
      return {
        ...state,
        jsonData: action.payload,
        // {
        //   ...state.jsonData,
        //   ...action.payload,
        // },
      };
    case "JSONRSL":
      return {
        ...state,
        jsonRSL: action.payload,
      };

    case "JSONRTN":
      return {
        ...state,
        jsonReturns: action.payload,
        //{
        //   ...state.jsonReturns,
        //   ...action.payload,
        // },
      };
    case "JSONVOL":
      return {
        ...state,
        jsonVol: action.payload,
        // {
        //   ...state.jsonVol,
        //   ...action.payload,
        // },
      };
    case "SET_AUTHTOKEN":
      return {
        ...state,
        authToken: action.payload,
      };

    case "TICKER_NAME":
      return {
        ...state,
        TickerName: [action.payload],
      };
    case "TICKER_DETIALS":
      return {
        ...state,
        TickerDetails: [...state.TickerDetails, action.payload],
      };
    case "ACTIVE_BUTTON":
      return {
        ...state,
        ActiveButton: action.payload,
      };
    case "WELCOME_PAGE":
      return {
        ...state,
        welcomePage: action.payload,
      };

    case "SELECTED_DROPDOWN_OPTION":
      return {
        ...state,
        SelectedDropdownOption: action.payload,
      };

    case "RSLEVEL_CLASSIC":
      return {
        ...state,
        RsClassic: action.payload,
      };
    case "RSLEVEL_FIBO":
      return {
        ...state,
        RsFibo: action.payload,
      };
    case "SET_RETURNS":
      return {
        ...state,
        Returns: action.payload,
      };
    case "SET_PAGE":
      return {
        ...state,
        SetPage: action.payload,
      };
    case "ROWS_PER_PAGE":
      return {
        ...state,
        RowsPerPage: action.payload,
      };

    case "SET_EXCHANGE":
      return {
        ...state,
        SetExchange: action.payload,
      };
    case "IS_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_INDICATORS":
      return {
        ...state,
        indicator: [...state.indicator, action.payload],
      };
    case "SEARCH_ITEM":
      return {
        ...state,
        SearchItems: [...state.SearchItems, action.payload],
      };
    case "TABLE_DATA":
      return {
        ...state,
        TableItem: [...state.TableItem, action.payload],
      };
    case "SHOWAPPBAR":
      return {
        ...state,
        showAppBar: action.payload,
      };

    case "SEARCH_VALUE":
      return {
        ...state,
        searchvalue: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        SetError: action.payload,
      };
    case "SET_CHECKED":
      return {
        ...state,
        checked: action.payload,
      };
    case "SET_ISAUTHENTICATED":
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case "SELECTED_ANALYTICS":
      return {
        ...state,
        selectedAnalytics: action.payload,
      };
    case "CHECK_SAMPLE":
      return {
        ...state,
        sample: action.payload,
      };
    case "SET_VOLUME_ANALYSIS":
      return {
        ...state,
        VolumeAnalysis: action.payload,
      };
    case "MEAN_REVERSION":
      return {
        ...state,
        meanReversion: action.payload,
      };
    case "KEY_METRICS":
      return {
        ...state,
        keyMetrics: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
